/**
 * @generated SignedSource<<b4f50333b3dec23986fa8f8de765d379>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ThumbnailMimeTypeEnum = "imageGif" | "imageJpg" | "imagePng" | "imageSvgXml" | "imageWebp" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ArticleSEOContainer_feedContentResource$data = {
  readonly __typename: string;
  readonly authors?: ReadonlyArray<{
    readonly name: string;
  }>;
  readonly canonicalUrlOverride: string;
  readonly dek: {
    readonly plaintext: string;
  };
  readonly featuredImage: {
    readonly image: {
      readonly alt: string;
      readonly originalHeight: number;
      readonly originalWidth: number;
      readonly thumbnails: {
        readonly social: {
          readonly cropCoordinates: {
            readonly height: number;
            readonly width: number;
          };
          readonly mimeType: ThumbnailMimeTypeEnum;
          readonly normalizedRatio: number;
          readonly url: string;
        };
      };
      readonly title: string;
    };
  } | null;
  readonly ledeMedia: {
    readonly image?: {
      readonly alt: string;
      readonly originalHeight: number;
      readonly originalWidth: number;
      readonly thumbnails: {
        readonly social: {
          readonly cropCoordinates: {
            readonly height: number;
            readonly width: number;
          };
          readonly mimeType: ThumbnailMimeTypeEnum;
          readonly normalizedRatio: number;
          readonly url: string;
        };
      };
      readonly title: string;
    };
  } | null;
  readonly originalPublishedAt: string | null;
  readonly permalink: string;
  readonly primaryCampaign: {
    readonly id: string;
  } | null;
  readonly promo: {
    readonly headline: string;
  };
  readonly publishedAt: string | null;
  readonly quickAttachment?: {
    readonly __typename: "CoreGalleryBlockType";
    readonly images: ReadonlyArray<{
      readonly image: {
        readonly alt: string;
        readonly originalHeight: number;
        readonly originalWidth: number;
        readonly thumbnails: {
          readonly social: {
            readonly cropCoordinates: {
              readonly height: number;
              readonly width: number;
            };
            readonly mimeType: ThumbnailMimeTypeEnum;
            readonly normalizedRatio: number;
            readonly url: string;
          };
        };
        readonly title: string;
      } | null;
    }>;
  } | {
    readonly __typename: "CoreImageBlockType";
    readonly image: {
      readonly alt: string;
      readonly originalHeight: number;
      readonly originalWidth: number;
      readonly thumbnails: {
        readonly social: {
          readonly cropCoordinates: {
            readonly height: number;
            readonly width: number;
          };
          readonly mimeType: ThumbnailMimeTypeEnum;
          readonly normalizedRatio: number;
          readonly url: string;
        };
      };
      readonly title: string;
    } | null;
  } | {
    readonly __typename: "ImageSliderBlockType";
    readonly images: ReadonlyArray<{
      readonly image: {
        readonly alt: string;
        readonly originalHeight: number;
        readonly originalWidth: number;
        readonly thumbnails: {
          readonly social: {
            readonly cropCoordinates: {
              readonly height: number;
              readonly width: number;
            };
            readonly mimeType: ThumbnailMimeTypeEnum;
            readonly normalizedRatio: number;
            readonly url: string;
          };
        };
        readonly title: string;
      } | null;
    }>;
  } | {
    readonly __typename: "VideoBlockType";
    readonly video: {
      readonly poster: {
        readonly alt: string;
        readonly originalHeight: number;
        readonly originalWidth: number;
        readonly thumbnails: {
          readonly social: {
            readonly cropCoordinates: {
              readonly height: number;
              readonly width: number;
            };
            readonly mimeType: ThumbnailMimeTypeEnum;
            readonly normalizedRatio: number;
            readonly url: string;
          };
        };
        readonly title: string;
      } | null;
    } | null;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
  readonly robots: {
    readonly follow: boolean;
    readonly index: boolean;
  };
  readonly seo: {
    readonly description: string;
    readonly headline: string;
  };
  readonly seoArticleBody?: string;
  readonly social: {
    readonly description: string;
    readonly headline: string;
    readonly image: {
      readonly alt: string;
      readonly originalHeight: number;
      readonly originalWidth: number;
      readonly thumbnails: {
        readonly social: {
          readonly cropCoordinates: {
            readonly height: number;
            readonly width: number;
          };
          readonly mimeType: ThumbnailMimeTypeEnum;
          readonly normalizedRatio: number;
          readonly url: string;
        };
      };
      readonly title: string;
    } | null;
  };
  readonly streamPublishedAt?: string | null;
  readonly title: string;
  readonly " $fragmentType": "ArticleSEOContainer_feedContentResource";
};
export type ArticleSEOContainer_feedContentResource$key = {
  readonly " $data"?: ArticleSEOContainer_feedContentResource$data;
  readonly " $fragmentSpreads": FragmentRefs<"ArticleSEOContainer_feedContentResource">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "headline",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v4 = [
  (v1/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "alt",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "originalHeight",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "originalWidth",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "ThumbnailMapType",
    "kind": "LinkedField",
    "name": "thumbnails",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ThumbnailType",
        "kind": "LinkedField",
        "name": "social",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "url",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "mimeType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "normalizedRatio",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CoordinatesType",
            "kind": "LinkedField",
            "name": "cropCoordinates",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "height",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "width",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "ImageResourceType",
  "kind": "LinkedField",
  "name": "image",
  "plural": false,
  "selections": (v4/*:: as any*/),
  "storageKey": null
},
v6 = [
  (v5/*:: as any*/)
],
v7 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CoreImageBlockType",
    "kind": "LinkedField",
    "name": "images",
    "plural": true,
    "selections": (v6/*:: as any*/),
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ArticleSEOContainer_feedContentResource",
  "selections": [
    (v0/*:: as any*/),
    (v1/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "RichTextType",
      "kind": "LinkedField",
      "name": "dek",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "plaintext",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RobotsType",
      "kind": "LinkedField",
      "name": "robots",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "index",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "follow",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "permalink",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canonicalUrlOverride",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "originalPublishedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "publishedAt",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AuthorProfileResourceType",
          "kind": "LinkedField",
          "name": "authors",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "FeedContentResourceInterface",
      "abstractKey": "__isFeedContentResourceInterface"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CampaignResourceType",
      "kind": "LinkedField",
      "name": "primaryCampaign",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ShareableDataType",
      "kind": "LinkedField",
      "name": "seo",
      "plural": false,
      "selections": [
        (v2/*:: as any*/),
        (v3/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ShareableDataType",
      "kind": "LinkedField",
      "name": "social",
      "plural": false,
      "selections": [
        (v2/*:: as any*/),
        (v3/*:: as any*/),
        (v5/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PromoDataType",
      "kind": "LinkedField",
      "name": "promo",
      "plural": false,
      "selections": [
        (v2/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "ledeMedia",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": (v6/*:: as any*/),
          "type": "LedeMediaImageType",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FeaturedImageType",
      "kind": "LinkedField",
      "name": "featuredImage",
      "plural": false,
      "selections": (v6/*:: as any*/),
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "streamPublishedAt",
          "storageKey": null
        }
      ],
      "type": "StreamResourceType",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "seoArticleBody",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "quickAttachment",
          "plural": false,
          "selections": [
            (v0/*:: as any*/),
            {
              "kind": "InlineFragment",
              "selections": (v6/*:: as any*/),
              "type": "CoreImageBlockType",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "VolumeVideoResourceType",
                  "kind": "LinkedField",
                  "name": "video",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ImageResourceType",
                      "kind": "LinkedField",
                      "name": "poster",
                      "plural": false,
                      "selections": (v4/*:: as any*/),
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "type": "VideoBlockType",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v7/*:: as any*/),
              "type": "ImageSliderBlockType",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v7/*:: as any*/),
              "type": "CoreGalleryBlockType",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "QuickPostResourceType",
      "abstractKey": null
    }
  ],
  "type": "ContentResourceInterface",
  "abstractKey": "__isContentResourceInterface"
};
})();

(node as any).hash = "e22652dd572c03c983f7ca6c4b945fe9";

export default node;
